module.exports = __webpack_public_path__ + "static/media/2.6f4c25a9.png";